

import {Options, Vue} from 'vue-class-component';
import {RestService} from "../service/rest.service";
import PaginationComponent from "@/components/pagination/PaginationComponent.vue";

@Options({
  components: {
    PaginationComponent
  }
})
export default class AIoTAcceleratorView extends Vue {

  restService = new RestService('events')
  activitiesService = new RestService('aiot/activities')
  tab = 1
  activities: any = []
  mentors: any = []
  teams: any = []
  highlights: any = []
  years2: any = []
  selectedYear2!: number;
  years3: any = []
  selectedYear3!: number;
  totalPages3 = 0

  changeTab(n: number) {
    this.tab = n
  }

  mounted() {
    // 取得 AIoT 活動消息（創業新訊、亮點成果、近期活動中有打勾顯示於 AIoT 前台的資料）
    this.activitiesService.gets().then((data: any) => {
      this.activities = data
    })

    this.restService.getsBy('/../mentors/years').then((data: any) => {
      this.years2 = data
      this.selectedYear2 = this.years2[0]
      this.getTab2()
    })

    this.restService.getsBy('/../highlights/years').then((data: any) => {
      if (data.length <= 0) return;
      this.years3 = data
      this.selectedYear3 = this.years3[0]
      this.getTab3()
    })
  }

  getTab2() {
    this.restService.getsBy('/../mentors', {year: this.selectedYear2}).then((data: any) => {
      this.mentors = data
    })

    this.restService.getsBy('/../teams', {year: this.selectedYear2}).then((data: any) => {
      this.teams = data
    })
  }

  getTab3(page = 1) {
    this.restService.getsBy('/../highlights', {year: this.selectedYear3, page: page}).then((data: any) => {
      this.highlights = data.content
      this.totalPages3 = data.totalPages
    })
  }

  onYearChange2() {
    this.getTab2();
  }

  onYearChange3() {
    this.getTab3();
  }

  changePage3(page: number) {
    this.getTab3(page);
  }

  /**
   * 格式化建立日期，只取 yyyy-MM-dd 部分
   */
  formatDate(dateStr: string): string {
    if (!dateStr) return ''
    return dateStr.substring(0, 10)
  }
}
